// Common error handle function for bookings
export function bookingsErrorHandling(bookingsErrors): string[] {
  const errorMessages = []
  bookingsErrors.forEach((value) => {
    switch (value.code) {
      case 'BLANK':
        errorMessages.push('入力値が空白です。')
        break
      case 'INVALID':
        errorMessages.push('適切な値を入力してください。')
        break
      case 'NOT_FOUND':
        errorMessages.push('対象を見つけることができません。')
        break
      case 'UNAVAILABLE':
        errorMessages.push(
          '選択した施設はご指定の日時では予約できません。 カレンダーを再度ご確認ください。'
        )
        break
      case 'UNDEFINED_PRODUCT':
        errorMessages.push('登録されていない施設が含まれています')
        break
      case 'CUSTOMER_NOT_FOUND':
        errorMessages.push('指定されたお客様の登録はありません。')
        break
      case 'NOT_DRAFT':
        errorMessages.push('下書きではない予約を削除することはできません。')
        break
      case 'NOT_FOR_SALE':
        errorMessages.push(
          '選択されたバリエーションは予約の枠に空きがありません'
        )
        break
      case 'DUPLICATE':
        errorMessages.push('入力値が重複しています。')
        break
      case 'QUANTITY_ZERO':
        errorMessages.push('数量0の予約はできません。')
        break
      case 'TOO_SHORT' || 'TOO_LONG':
        errorMessages.push(
          '入力値が短すぎたり長すぎたりしないことを確認してください。'
        )
        break
      case 'INVALID_DATE':
        errorMessages.push(
          '終了日より後の日付で開始日を設定することはできません。'
        )
        break
      case 'UNAVAILABLE_PRODUCT':
        errorMessages.push('選択した1つ以上の製品が利用できません。')
        break
      case 'REQUIRED':
        errorMessages.push(
          '予約をオンラインで公開する場合に必要な入力値が不足しています。'
        )
        break
      case 'TOO_CLOSE':
        errorMessages.push(
          '変更可能期限が過ぎているため、この予約を変更することはできません。'
        )
        break
      case 'PAST_ORDER':
        errorMessages.push('過去の予約は変更できません。')
        break
      // TODO: API 側での用途が確定次第文言を修正
      case 'SHOULD_BE_UPDATED':
        errorMessages.push('代わりに注文を更新してください。')
        break
      case 'DUPLICATE_DATES':
        errorMessages.push('同じ日付を予約することはできません。')
        break
      case 'MAIL_SENDING_ERROR':
        errorMessages.push('メール送信時にエラーが発生しました。')
        break
      case 'INVALID_PERIOD':
        errorMessages.push('開始時刻は終了時刻よりも前でなければなりません。')
        break
      case 'DATE_NOT_FOUND':
        errorMessages.push('更新対象の日付が予約に存在しません。')
        break
      case 'INVALID_CHECKIN_TIME':
        errorMessages.push(
          'チェックイン時間はチェックアウト時間より前でなければなりません。'
        )
        break
      case 'INVALID_CHECKOUT_TIME':
        errorMessages.push(
          'チェックアウト時間はチェックインの時間より後でなければなりません。'
        )
        break
      case 'CHECKIN_REQUIRED':
        errorMessages.push(
          'チェックインせずにチェックアウトすることはできません。'
        )
        break
      case 'TIMESTAMP_DATES':
        errorMessages.push(
          '同じ日付のタイムスタンプ情報を変更することはできません。'
        )
        break
      case 'FUTURE_DATE':
        errorMessages.push(
          '当日より未来の予約のチェックインステータスを変更することはできません。'
        )
        break
      case 'DISAPPROVED':
        errorMessages.push('非承認した予約の内容を変更することはできません。')
        break
      case 'RESERVATION_SLOT_CONFLICT':
        errorMessages.push(
          '予約対象に選択したバリデーションが施設の予約枠を超えています。\n[施設管理]⇒[予約枠共有グループの設定]から確認して下さい。'
        )
        break
      case undefined:
        errorMessages.push(...errorMessages)
        break
      default:
        errorMessages.push('エラーが発生しました。')
        break
    }
  })
  // Filter Duplicate item and return unique Array
  return errorMessages?.filter((e, i) => errorMessages?.indexOf(e) === i)
}
